import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import SignUpStyles from "./signUp.styles";
import { ReactComponent as HeadPhoneIcon } from "../../../../assets/icons/Headphones.svg";
import CustomInput from "../../../../global/components/CustomInput/CustomInput";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import VisibilityIcon from "../../../../assets/icons/VisibilityIcon.svg";
import VisibilityOffIcon from "../../../../assets/icons/VisibilityOff.svg";
import { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import SignUpOtp from "./SignUpOtp/SignUpOtp";
import history from "../../../../utils/history";
import urls from "../../../../global/constants/UrlConstants";

const SignUp = () => {
  const classes = SignUpStyles;
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showVerifyDialog, setShowVerifyDialog] = useState<boolean>(false);

  const handleClickShowPassword = () => {
    setShowPassword(showPassword);
  };

  const handleMouseDownNewPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setShowPassword(!showPassword);
    event.preventDefault();
  };

  const handleVerifyButton = () => {
    setShowVerifyDialog(!showVerifyDialog);
  };

  const handleClose = () => {
    setShowVerifyDialog(false);
  };

  const handlenextButton = () => {
    history.push(urls.onBoadingSelectIndustryViewPath);
  };

  const getRightSection = () => {
    return (
      <>
        <Box>
          <Typography sx={classes.rightSectionHeading}>
            Sign up for a 21 day free trial
          </Typography>
        </Box>

        <Box sx={classes.inputsWrapper}>
          <CustomInput placeHolder="Full Name" />
          <CustomInput placeHolder="Work Email" />
          <CustomInput
            placeHolder="Work Email"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CustomButton
                    label="Verify"
                    onClick={() => handleVerifyButton()}
                  />
                </InputAdornment>
              ),
            }}
          />

          <CustomInput
            placeHolder="Create Password"
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownNewPassword}
                    edge="end"
                  >
                    {showPassword ? (
                      <img
                        src={VisibilityIcon}
                        style={{ margin: "8px" }}
                        alt="Visibility"
                      />
                    ) : (
                      <img
                        src={VisibilityOffIcon}
                        style={{ margin: "8px" }}
                        alt="VisibilityOff"
                      />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box>
          <Typography sx={classes.ipInfo}>
            It looks like you‘re in INDIA based on your IP.
          </Typography>
          <FormGroup>
            <FormControlLabel
              sx={classes.checkboxStyle}
              control={<Checkbox defaultChecked />}
              label="I agree to the Terms of Service and Privacy Policy."
            />
          </FormGroup>
        </Box>

        <Box>
          <CustomButton
            label="Next"
            onClick={() => {
              handlenextButton();
            }}
            buttonType="primaryBtn"
            customClasses={classes.nextButton}
          />
        </Box>
      </>
    );
  };

  return (
    <Box sx={classes.SignUpWrapper}>
      <Grid container>
        <Grid item xs={5}>
          <Box sx={classes.leftSection}>
            <Box>
              <Typography sx={classes.sectionHeading}>
                Try Pulse CRM for FREE
              </Typography>
              <Typography sx={classes.sectionSubText}>
                Try Pulse CRM for FREE
              </Typography>
              <Box sx={classes.listWrapper}>
                <List>
                  <ListItem sx={classes.listItemStyle}>
                    75% reduction in ticket resolution time
                  </ListItem>
                  <ListItem sx={classes.listItemStyle}>
                    3 month payback period
                  </ListItem>
                  <ListItem sx={classes.listItemStyle}>
                    54 hours per agent per year saved with automation
                  </ListItem>
                </List>
              </Box>
            </Box>

            <Box sx={classes.contactInfo}>
              <Typography sx={classes.needStyle}>Need assistance?</Typography>

              <List>
                <ListItem sx={classes.needListItems}>
                  <Box sx={classes.listHeading}>
                    <HeadPhoneIcon /> Toll free number
                  </Box>
                  <Box sx={classes.listInfo}>1800 105 1122</Box>
                </ListItem>
                <ListItem sx={classes.needListItems}>
                  <Box sx={classes.listHeading}>
                    <HeadPhoneIcon /> Sales Enquiry
                  </Box>
                  <Box sx={classes.listInfo}>sales@pulsecrm.com</Box>
                </ListItem>
                <ListItem sx={classes.needListItems}>
                  <Box sx={classes.listHeading}>
                    <HeadPhoneIcon /> Chat Support
                  </Box>
                  <Box sx={classes.listInfo}>Chat Now</Box>
                </ListItem>
              </List>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box sx={classes.rightSection}>{getRightSection()}</Box>
        </Grid>
      </Grid>

      {/* code  for otp dylogBox */}
      <SignUpOtp
        showVerifyDialog={showVerifyDialog}
        handleClose={handleClose}
      />
    </Box>
  );
};

export default SignUp;
